import React, { memo } from 'react'

import * as Styled from './styled'

interface IProps {
  src?: string
  onClick?: () => void
}
const RecentlyUsedImage: React.FC<IProps> = ({ src, onClick }) => {
  return (
    <Styled.RecentlyUsedImageWrapper onClick={onClick}>
      <Styled.RecentlyUsedImage src={src} />
    </Styled.RecentlyUsedImageWrapper>
  )
}

export default memo(RecentlyUsedImage)
